module.exports = __webpack_public_path__ + "static/media/sustainable-dev-goals.73415e17.png";